import { useRef } from 'react';
import { APPROVAL_NOT_MONEY_MOVEMENT_NOTE } from '../reviewCopy';
import { ReviewDialog } from './ReviewDialog';

interface Props {
  periodLabel: string;
  checkDateLabel: string;
  netPayLabel: string;
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Confirmation for Approve. Opens with focus on Cancel — the safe default for a consequential action. */
export function ApproveRunDialog({ periodLabel, checkDateLabel, netPayLabel, busy, error, onConfirm, onCancel }: Props) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  return (
    <ReviewDialog
      title="Approve this payroll run?"
      busy={busy}
      onClose={onCancel}
      initialFocusRef={cancelRef}
      description={
        <>
          <p>
            You are approving the payroll run for <strong>{periodLabel}</strong> (check date {checkDateLabel}) with a
            total net pay of <strong>{netPayLabel}</strong>.
          </p>
          <p className="muted">{APPROVAL_NOT_MONEY_MOVEMENT_NOTE}</p>
        </>
      }
    >
      {error && (
        <p className="error" role="alert">
          {error}
        </p>
      )}
      <div className="payroll-review__dialog-actions">
        <button type="button" ref={cancelRef} disabled={busy} onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="payroll-review__primary" disabled={busy} onClick={onConfirm}>
          {busy ? 'Approving…' : 'Approve payroll run'}
        </button>
      </div>
    </ReviewDialog>
  );
}
